import isApiError from "@insite/client-framework/Common/isApiError";
import {
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { AutocompleteModel } from "@insite/client-framework/Types/ApiModels";
import { GetSearchItems, SearchItemParameter } from "@tSurya/Services/SearchItemService";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";


type GetSearchItemParameter = HasOnSuccess<AutocompleteModel> & SearchItemParameter & HasOnError;

type HandlerType = CustomApiHandler<GetSearchItemParameter, AutocompleteModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
        productEnabled: true,
        brandEnabled: false,
        categoryEnabled: false,
        contentEnabled: false,
    };
    // props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = (await GetSearchItems(props.apiParameter)) as AutocompleteModel;
    } 
    catch(error){
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
        }
        throw error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const searchItem = createHandlerChainRunner(chain, "SearchItem");
export default searchItem;